import { Address, AddressInfo } from '../../types/address';

/**
 *
 * @param address 用户地址
 * @returns 转换为提单页addressInfo
 */
export function convert2AddressInfo(address: Address) {
  if (!address) {
    return null;
  }
  const addressInfo: AddressInfo = {
    addressId: address.addressId ? Number(address.addressId) : 0,
    receiverName: address.name,
    receiverPhone: address.phone,
    receiverInnerCode: address.interCode,
    receiverLocation: address.addressLocation,
    receiverAddress: address.addressName,
    receiverHouseNumber: address.houseNumber,
    receiverLatitude: address.latitude,
    receiverLongitude: address.longitude,
    unitNumber: address.unitNumber || '',
    buildingNumber: address.buildingNumber || '',
    extra: address.extra,
    orderExtra: address.orderExtra,
    labelName: address.labelName,
    labelIcon: address.labelIcon,
    structType: address.structType,
    addressDetail: address.addressDetail || '',
    addressSnapshotCode: address.addressSnapshotCode || '',
    detailsV2: address.detailsV2 || ''
  };
  return addressInfo;
}

/**
 * 转换为 Native 存储的 addressInfo 的格式
 * @param address
 */
export function convertLocalAddressInfo(address: AddressInfo) {
  if (!address) {
    return null;
  }
  const addressInfo = {
    addressId: address.addressId ? Number(address.addressId) : 0,
    name: address.receiverName,
    phone: address.receiverPhone,
    interCode: address.receiverInnerCode,
    addressLocation: address.receiverLocation,
    addressName: address.receiverAddress,
    houseNumber: address.receiverHouseNumber,
    latitude: address.receiverLatitude,
    longitude: address.receiverLongitude,
    unitNumber: address.unitNumber || '',
    buildingNumber: address.buildingNumber || '',
    extra: address.extra,
    orderExtra: address.orderExtra,
    labelName: address.labelName,
    labelIcon: address.labelIcon,
    structType: address.structType,
    addressDetail: address.addressDetail || '',
    addressSnapshotCode: address.addressSnapshotCode || '',
    detailsV2: address.detailsV2 || ''
  };
  return addressInfo;
}
